import React from "react";
import { Asterisk } from "lucide-react";

import { tw } from "@/utils";

interface FormFieldProps {
  label?: string;
  error?: string;
  hasLabelSpacing?: boolean;
  hasAsterisk?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  error,
  children,
  hasLabelSpacing,
  hasAsterisk,
  className,
}) => (
  <div className={tw("flex w-full flex-col gap-3", className)}>
    <label
      className={tw(
        "flex font-medium text-primary-950",
        hasLabelSpacing && "pb-6",
      )}
    >
      {label ?? "\u00A0"}
      {hasAsterisk && <Asterisk className="text-primary-600" size={12} />}
    </label>
    {children}
    {error && <p className="text-error-400">{error}</p>}
  </div>
);
